<template>
  <div>

    <div v-if="local_item.recurring_id && local_item.event_id !== local_item.recurring_id" class="empty-participant-message">
      <i class="mdi mdi-calendar big-icon"></i>

      <p class="info-text">Återkommande evenemang.</p>
      <p>Detta evenemang är del av ett redan återkommande evenemang. Du kan inte skapa ett återkommande evenemang inuti ett återkommande evenemang.</p>
      
    </div>
    <div v-else-if="!local_item.recurring || !local_item.recurring.enabled" class="empty-participant-message">
      <i class="mdi mdi-calendar big-icon"></i>

      <p class="info-text">Återkommande evenemang ej aktiverat.</p>
      <p>När evenemanget ställts in som återkommande har du möjlighet att bestämma vilka dagar i veckan som evenemanget ska återkomma.</p>

      <memlist-icon-button
        class="mt-4"
        icon="menu-icon flaticon2-plus"
        :text="$t('EVENT.ACTIVATE_RECURRING')"
        variant="primary"
        @click="activate_recurring_clicked"
      />
    </div>
    <div v-else>

      <m-row class="mt-2">
        <m-col lg="12">

          <memlist-checkbox
            class="mt-6"
            :text="$t('EVENT.ACTIVATE_RECURRING')"
            v-model="local_item.recurring.enabled"
            @input="on_change"
          />

        </m-col>
      </m-row>
      
      <m-row class="mt-8">
        <m-col lg="12">
          <QuestionRadioOptions
            group="every-radio"
            :item="every_option"
            :preselected="local_item.recurring.option"
            @selected="recurring_option_selected"
          />
        </m-col>
      </m-row>

      <div v-if="local_item.recurring.option === 'WEEKLY'">
        <p class="mt-4"><b>{{$t('EVENT.CREATE_RECURRING_EVERY')}}</b></p>

        <m-row>
          <m-col lg="4">
            <memlist-checkbox
              value="monday"
              v-model="every.monday"
              :text="$t(`CALENDAR.DAYS.MONDAY`)"
              @input="on_change"
            />

            <memlist-checkbox
              value="tuesday"
              v-model="every.tuesday"
              :text="$t(`CALENDAR.DAYS.TUESDAY`)"
              @input="on_change"
            />

            <memlist-checkbox
              value="wednesday"
              v-model="every.wednesday"
              :text="$t(`CALENDAR.DAYS.WEDNESDAY`)"
              @input="on_change"
            />

            <memlist-checkbox
              value="thursday"
              v-model="every.thursday"
              :text="$t(`CALENDAR.DAYS.THURSDAY`)"
              @input="on_change"
            />


          </m-col>
          <m-col lg="4">

            <memlist-checkbox
              value="friday"
              v-model="every.friday"
              :text="$t(`CALENDAR.DAYS.FRIDAY`)"
              @input="on_change"
            />

            <memlist-checkbox
              value="saturday"
              v-model="every.saturday"
              :text="$t(`CALENDAR.DAYS.SATURDAY`)"
              @input="on_change"
            />


            <memlist-checkbox
              value="sunday"
              v-model="every.sunday"
              :text="$t(`CALENDAR.DAYS.SUNDAY`)"
              @input="on_change"
            />

          </m-col>
        </m-row>

        <m-row>
          <m-col lg="6">

            <memlist-text-input
              class="mt-8"
              id="input-num_weeks"
              name="num_weeks"
              :title="$t('EVENT.NUM_WEEKS')"
              layout="vertical"
              validation_type="TEXT"
              v-model="local_item.recurring.num_weeks"
              required
              @input="on_change_num_weeks"
            />

          </m-col>
          <m-col lg="6">
            <memlist-spinner-icon-button
              ref="create-events-button"
              class="mt-16"
              icon="menu-icon flaticon2-list"
              :text="$t('EVENT.CREATE_CHILD_EVENTS')"
              variant="primary"
              @click="create_child_events"

            />

          </m-col>

        </m-row>
      </div>

      <div v-if="local_item.recurring.option === 'MONTHLY'">
        <m-row class="mt-8">
          <m-col lg="12">
            <QuestionRadioOptions 
              group="monthly-radio"
              :item="monthly_option"
              :preselected="local_item.recurring.monthly_option"
              @selected="monthly_option_selected"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4" v-if="local_item.recurring.monthly_option === 'ON_DATE'">
          <m-col lg="12">
            <memlist-select-input2
              :title="$t('EVENT.ON_DATE')"
              layout="vertical"
              v-model="local_item.recurring.monthly_every"
              :items="monthly_every_day_options"
              :show_none="false"
              class="mr-2"
             
              @input="monthly_every_day_change"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4" v-if="local_item.recurring.monthly_option === 'ON_FIRST'">
          <m-col lg="12">
            <memlist-select-input2
              :title="$t('EVENT.ON_FIRST')"
              v-model="local_item.recurring.monthly_every"
              layout="vertical"
              :items="weekday_options"
              :show_none="false"
              class="mr-2"

              @input="weekday_change"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4" v-if="local_item.recurring.monthly_option === 'ON_LAST'">
          <m-col lg="12">
            <memlist-select-input2
              :title="$t('EVENT.ON_LAST')"
              v-model="local_item.recurring.monthly_every"
              layout="vertical"
              :items="weekday_options"
              :show_none="false"
              class="mr-2"

              @input="weekday_change"
            />
          </m-col>
        </m-row>

        <m-row>
          <m-col lg="6">

            <memlist-text-input
              class="mt-8"
              id="input-num_months"
              name="num_months"
              :title="$t('EVENT.NUM_MONTHS')"
              layout="vertical"
              validation_type="TEXT"
              v-model="local_item.recurring.num_months"
              required
              @input="on_change_num_months"
            />

          </m-col>
          <m-col lg="6">
            <memlist-spinner-icon-button
              ref="create-events-button"
              class="mt-16"
              icon="menu-icon flaticon2-list"
              :text="$t('EVENT.CREATE_CHILD_EVENTS')"
              variant="primary"
              @click="create_child_events"

            />

          </m-col>

        </m-row>

      </div>

      
      <m-row class="mt-4">
        <m-col lg="6">
          <memlist-datetime-picker
            class="mt-8"
            :label="$t('EVENT.START_TIME')"
            v-model="local_item.from_datetime"
            @input="on_change"
          />

        </m-col>
        <m-col lg="6">
          
        </m-col>
      </m-row>
      
      

      <memlist-static-table
        id="recurring-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped mt-8"
        :fields="recurring_headers"
        :items="recurring_items"
        head-variant="light"
        ref="recurring-table"
      >
        <template #cell(actions)="data">

          <div class='d-flex justify-content-end'>
            <memlist-table-button @click="edit_recurring_clicked(data.item)" class="mr-2" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
            <memlist-table-button @click="delete_recurring_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
          </div>
        </template>

      </memlist-static-table>

      <Confirm
        :title="$t('EVENT.TICKET.DELETE_TICKET')"
        :message="$t('EVENT.TICKET.DELETE_TICKET_INFO')"
        ref="delete-ticket"
        :type="'success'"
        :confirm="$t('COMMON.YES')"
        :cancel="$t('COMMON.NO')"
        @confirm="delete_ticket_confirm"
      />
    </div>
  </div>
</template>

<script>
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import EventTicketEditorModal from '@/view/pages/ml/events/forms/EventTicketEditorModal.vue';
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import EventFormAvailability from './EventFormAvailability.vue';
import QuestionRadioOptions from '@/view/components/questions/QuestionRadioOptions.vue';

export default {
  name: 'EventFormRecurring',
  props: ['item'],
  mixins: [ toasts ],
  components: {
    EventTicketEditorModal,
    EventFormAvailability,
    QuestionRadioOptions
  },
  computed: {
    weekday_options() {
      let r = [];

      for (const w of this.daysOfWeek) {
        r.push({ value: w, text: this.$t('CALENDAR.DAYS.' + w.toUpperCase()) });
      }

      return r;
    },
    monthly_every_day_options() {
      return [
        { text: '1:a', value: 1 },
        { text: '2:a', value: 2 },
        { text: '3:e', value: 3 },
        { text: '4:e', value: 4 },
        { text: '5:e', value: 5 },
        { text: '6:e', value: 6 },
        { text: '7:e', value: 7 },
        { text: '8:e', value: 8 },
        { text: '9:e', value: 9 },
        { text: '10:e', value: 10 },
        { text: '11:e', value: 11 },
        { text: '12:e', value: 12 },
        { text: '13:e', value: 13 },
        { text: '14:e', value: 14 },
        { text: '15:e', value: 15 },
        { text: '16:e', value: 16 },
        { text: '17:e', value: 17 },
        { text: '18:e', value: 18 },
        { text: '19:e', value: 19 },
        { text: '20:e', value: 20 },
        { text: '21:a', value: 21 },
        { text: '22:a', value: 22 },
        { text: '23:e', value: 23 },
        { text: '24:e', value: 24 },
        { text: '25:e', value: 25 },
        { text: '26:e', value: 26 },
        { text: '27:e', value: 27 },
        { text: '28:e', value: 28 },
        { text: '29:e', value: 29 },
        { text: '30:e', value: 30 },
        { text: '31:a', value: 31 },
      ]
    },
    daysOfWeek() {
      return [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'];
    } 
  },
  watch: {

    every: {
      deep: true,
      handler(val) {
        console.log('every deep mutate');
        this.every_object_to_array();
      },
      immediate: true
    },

    item: {
      deep: true,
      handler(val) {
        console.log('test');
        this.load_recurring_events(this.item.event_id);
        this.local_item = JSON.parse(JSON.stringify(this.item));
        this.every_array_to_object();
      },
      immediate: true
    },
    
  },
  data() {
    return {
      monthly_option: {
        name: this.$t('EVENT.MONTHLY_RECURRENCE'),
        options: [ 
          { value: 'ON_DATE', text: this.$t('EVENT.ON_DATE') }, 
          { value: 'ON_FIRST', text: this.$t('EVENT.ON_FIRST') },
          { value: 'ON_LAST', text: this.$t('EVENT.ON_LAST') } 
        ]
      },
      every_option: {
        name: this.$t('EVENT.RECURRING_TYPE'),
        options: [ 
          { value: 'WEEKLY', text: this.$t('EVENT.WEEKLY') }, 
          { value: 'MONTHLY', text: this.$t('EVENT.MONTHLY') } 
        ]
      },


      every: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
      
      
      recurring_items: [],

      recurring_headers: [
        {
          key: 'name',
          label: this.$t('EVENT.EVENT'),
          sortable: true,
          thClass: 'pl-7 align-middle',
          tdClass: 'pl-7'
        },
        {
          key: 'from_datetime',
          label: this.$t('EVENT.FROM_DATETIME'),
          sortable: true,
          thClass: 'w-150px align-middle',
          tdClass: 'w-150px',
        },
        
        {
          key: 'num_signups',
          label: this.$t('EVENT.NUM_SIGNUPS'),
          sortable: true,
          thClass: 'w-150px align-middle',
          tdClass: 'w-150px',
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'text-right',
        },
      ],

      local_item: {}
    }
  },
  methods: {

    on_change_num_months(val) {
      this.local_item.recurring.num_months = parseInt(val+'');

      this.on_change();
    },

    on_change_num_weeks(val) {
      this.local_item.recurring.num_weeks = parseInt(val+'');

      this.on_change();
    },

    weekday_change(val) {
      this.on_change();
    },

    monthly_every_day_change(val) {

      this.local_item.recurring.monthly_every = parseInt(val+'');

      this.on_change();
    },

    monthly_option_selected(option) {
      console.log('option', option);
      this.local_item.recurring.monthly_option = option;

      this.local_item = { ...this.local_item };

      this.on_change();
    },
    recurring_option_selected(option) {
      console.log('option', option);
      this.local_item.recurring.option = option;

      this.local_item = { ...this.local_item };

      this.on_change();
    },

    async create_child_events() {
      try {
        const res = await axios.post(`/events/${this.local_item.event_id}/recurring`, {});

        if (res.status === 201) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.RECURRING_CREATED'));

          this.recurring_items = res.data;
          this.$emit('recurring_created', this.recurring_items);
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_CREATE_RECURRING'));
        }
      }
      catch (err) {
        console.error('create_child_events error', err);
      }
      
      this.$refs['create-events-button'].stop();
    },

    
    every_object_to_array() {
      if (!this.local_item || !this.local_item.recurring) {
        return;
      }

      this.local_item.recurring.every = [];

      for (const day of this.daysOfWeek) {
        if (this.every[day]) {
          this.local_item.recurring.every.push(day);
        }
      }
    },

    every_array_to_object() {
      if (!this.local_item || !this.local_item.recurring) {
        return;
      }

      for (const day of this.daysOfWeek) {
        const index = this.local_item.recurring.every.findIndex(i => i === day);

        this.every[day] = index >= 0;
      }
    },

    edit_recurring_clicked(event) {},
    delete_recurring_clicked(event) {},

    activate_recurring_clicked() {
      this.local_item.recurring = {
        enabled: true,
        start_date: this.local_item.from_datetime,
        num_weeks: 1,
        every: []
      }

      this.$emit('change', this.local_item);
    },

    async load_recurring_events(event_id) {
      try {
        const res = await axios.get(`/events/${event_id}/recurring`);

        if (res.status === 200) {
          this.recurring_items = res.data;

          return;
        }

      }
      catch (err) {
        console.error('load_recurring_events error', err);
      }

      this.recurring_items = [];
    },

    on_change() {

      console.log('on change', this.local_item.recurring)
      
      this.event_changed(this.local_item);
    },

    event_changed(item) {
      this.$emit('change', item);
    },

    update_event(item) {
      this.$emit('update', item);
    },

    create_event(item) {
      this.$emit('create', item);
    },

    save_event() {},

  }
}
</script>
<style scoped>
.empty-participant-message {
  text-align: center;
  padding: 4rem 1rem;
  background: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.big-icon {
  font-size: 4rem;
  color: #2D9BF0;
  margin-bottom: 1rem;
}

.info-text {
  font-size: 1.2rem;
  color: #555;
}
</style>